<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Material Icons &#40;MDI&#41;</h1>
					<p waBody="m" waText>Material Design Icons &#40;Community&#41; &mdash; 2,000+ icons using the mdi- CSS class prefix. Older community icon set with web font rendering via CDN or local CSS.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">MDI 2.4.85</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:material-icons</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.materialicons</p>
					<p waBody="s" waText>Built on: Material Design Icons &#40;Community&#41; 2.4.85</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_625" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_626" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;3&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>MDIIcon</h4>
								<p waBody="s" waColorText="quiet" waText>CRTP italic-based icon component for Material Design Icons &#40;Community&#41;. Renders mdi- prefixed CSS classes. Implements IIcon.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">1 props</wa-tag>
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/material-icons/mdiicon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>MDIIcons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 2,000+ Material Design Community icon constants with mdi- CSS class prefix.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">7 props</wa-tag>
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/material-icons/mdiicons']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>MaterialIconsPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Page configurator that auto-registers the materialdesignicons.min.css stylesheet &#40;local or CDN&#41;. Implements IPageConfigurator.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">1 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/material-icons/material-icons-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (5)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>2,000+ community material design icons &mdash; comprehensive mdi- prefixed CSS icon set</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API &mdash; MDIIcons with compile-time safety</p>
						<p waBody="s" waColorText="quiet" waText>MDIIcon component &mdash; italic-based CRTP icon element with IIcon interface</p>
						<p waBody="s" waColorText="quiet" waText>CDN support &mdash; optional CDN URL for materialdesignicons.min.css</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Create MDI icons</h4>
							<p waBody="s" waColorText="quiet" waText>Use the MDIIcon component with type-safe enum.</p>
							<markdown [data]="mdContent_627" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_628" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>MaterialIconsPageConfigurator auto-registers MDI CSS</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://materialdesignicons.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>